/**
 * Hulk Product Options — Split Pricing Message
 * ------------------------------------------------
 * Hulk's own "Selection will add $X to the price" message blends one-time
 * setup fees and per-item variable charges into a single number. This
 * script re-reads the same data Hulk uses (the data-price attribute on
 * each <option>, plus its text) and renders a clearer, split message:
 *
 *   "Selected options will add $44.95 per item and $24.95 one-time to the price"
 *
 * HOW IT DETECTS ONE-TIME VS PER-ITEM:
 * Hulk does not expose a structured "price type" field anywhere (checked
 * the window object, the cart.js JSON, and the raw option HTML — none of
 * them carry it). The only signal is the literal phrase "One-Time Setup"
 * inside the option's visible text / data-display-val. This script matches
 * on that phrase. See the ONE_TIME_PATTERN below — extend it if you find
 * other wordings used elsewhere in your catalog (e.g. "One Time Fee").
 *
 * WHERE TO ADD THIS:
 * Paste this file's contents into a new theme asset (e.g.
 * assets/hulk-price-split.js) and load it on product pages only, e.g. in
 * sections/main-product.liquid or product-template.liquid, near the
 * bottom, after Hulk's own scripts:
 *
 *   <script src="{{ 'hulk-price-split.js' | asset_url }}" defer></script>
 *
 * It only activates on pages where a .hulkapps_product_options container
 * exists, so it's safe to load sitewide if that's easier.
 */

(function () {
  'use strict';

  // Add more phrases here if other products use different wording for
  // one-time charges (case-insensitive match against option text).
  var ONE_TIME_PATTERN = /one[\s-]*time/i;

  function formatMoney(amount) {
    return '$' + amount.toFixed(2).replace(/\.00$/, '.00');
  }

  // Reads all currently-selected dropdown options within one Hulk
  // options container and splits their prices into one-time vs per-item.
  function computeSplit(container) {
    var oneTime = 0;
    var perItem = 0;

    var selects = container.querySelectorAll('select.hulkapps_option_child');
    selects.forEach(function (select) {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      var price = parseFloat(opt.getAttribute('data-price'));
      if (isNaN(price) || price === 0) return;

      var label = opt.getAttribute('data-display-val') || opt.value || opt.textContent || '';

      if (ONE_TIME_PATTERN.test(label)) {
        oneTime += price;
      } else {
        perItem += price;
      }
    });

    // NOTE: this covers dropdown-type options (select.hulkapps_option_child),
    // which is what we've confirmed so far. If this product/theme also uses
    // Hulk radio buttons, checkboxes, or text-input add-ons, those render
    // with different markup and aren't picked up by this selector yet —
    // let me know if you use those elsewhere and I'll extend it.

    return { oneTime: oneTime, perItem: perItem };
  }

  function buildMessage(split) {
    var parts = [];
    if (split.perItem > 0) parts.push(formatMoney(split.perItem) + ' per item');
    if (split.oneTime > 0) parts.push(formatMoney(split.oneTime) + ' one-time');

    if (parts.length === 0) return '';
    return 'Selected options will add ' + parts.join(' and ') + ' to the price';
  }

  function renderMessage(container, text) {
    var el = container.querySelector('#hulk_price_split_message');
    if (!el) {
      el = document.createElement('div');
      el.id = 'hulk_price_split_message';
      el.style.marginTop = '4px';
      el.style.fontWeight = '600';
      el.style.color = '#87A96B'; /* sage green */

      // Insert right after Hulk's own total display, if we can find it,
      // so the two sit together instead of the new one appearing at a
      // random spot in the DOM.
      var hulkTotal = container.querySelector('#option_display_total_format');
      if (hulkTotal && hulkTotal.parentNode) {
        hulkTotal.parentNode.insertBefore(el, hulkTotal.nextSibling);
      } else {
        container.appendChild(el);
      }
    }
    el.textContent = text;
    el.style.display = text ? '' : 'none';
  }

  function update(container) {
    var split = computeSplit(container);
    renderMessage(container, buildMessage(split));
  }

  function attach(container) {
    if (container.dataset.priceSplitAttached === 'true') return;
    container.dataset.priceSplitAttached = 'true';

    container.addEventListener('change', function (e) {
      if (e.target && e.target.matches('select.hulkapps_option_child')) {
        update(container);
      }
    });

    update(container);
  }

  function scan() {
    document.querySelectorAll('.hulkapps_product_options').forEach(attach);
  }

  // Hulk renders its option markup asynchronously after page load, so we
  // watch the DOM until the container(s) show up, then attach.
  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Also run once immediately in case Hulk has already rendered.
  document.addEventListener('DOMContentLoaded', scan);
  scan();
})();
